// Mock data for Xpert Consultant LLC website (frontend-only)

export const company = {
  name: 'Xpert Consultant',
  suffix: 'LLC',
  phone: '905 909 7555',
  phoneHref: 'tel:+19059097555',
  email: 'xpertcons1975@gmail.com',
  address: {
    line1: '9609 W 164th St',
    city: 'Overland Park, KS 66085',
    country: 'USA',
  },
};

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Support Services', href: '#support' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Shop Computers', route: '/shop' },
  { label: 'Antivirus Software', href: '#support' },
  { label: 'SonicWall Firewalls', href: '#support' },
];

export const stats = [
  { value: '5,000+', label: 'Happy Clients' },
  { value: '24/7', label: 'Support Available' },
  { value: '15+', label: 'Years Experience' },
  { value: '98%', label: 'Satisfaction Rate' },
];

export const whyChoose = [
  {
    icon: 'Zap',
    title: 'Fast Response Time',
    text: 'Average response time under 15 minutes. We understand that time is money in business.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Expert Technicians',
    text: 'Certified professionals with years of experience across all major platforms and software.',
  },
  {
    icon: 'Clock',
    title: '24/7 Availability',
    text: "Round-the-clock support means you're never alone when technical issues arise.",
  },
];

export const serviceTabs = {
  computer: {
    label: 'Computer Support',
    icon: 'Monitor',
    items: [
      { name: 'Dell', text: 'Complete support for Dell desktops, laptops, and workstations. Hardware diagnostics, driver updates, and performance optimization.' },
      { name: 'HP', text: 'Expert HP support including Pavilion, Envy, Omen, and EliteBook series. BIOS updates, hardware troubleshooting, and repairs.' },
      { name: 'Lenovo', text: 'ThinkPad, IdeaPad, and Yoga series support. System optimization, hardware upgrades, and technical assistance.' },
      { name: 'Apple', text: 'MacBook Pro, MacBook Air, iMac support. macOS troubleshooting, hardware diagnostics, and software installations.' },
      { name: 'ASUS', text: 'ROG, ZenBook, VivoBook support. Gaming optimization, cooling solutions, and performance tuning.' },
      { name: 'Acer', text: 'Aspire, Predator, Swift series support. System recovery, driver installation, and hardware repair.' },
      { name: 'Microsoft Surface', text: 'Surface Pro, Surface Laptop, Surface Book support. Windows updates, pen calibration, and system optimization.' },
      { name: 'Samsung', text: 'Galaxy Book and Notebook support. Display calibration, S Pen support, and system maintenance.' },
    ],
  },
  software: {
    label: 'Software Support',
    icon: 'Package',
    items: [
      { name: 'Microsoft Office', text: 'Installation, activation, and troubleshooting for Word, Excel, Outlook, and the full Office 365 suite.' },
      { name: 'Adobe Creative Cloud', text: 'Photoshop, Illustrator, Premiere Pro setup, licensing, and workstation optimization for creative teams.' },
      { name: 'Operating Systems', text: 'Windows and macOS installation, upgrades, migrations, and performance tuning for all devices.' },
      { name: 'QuickBooks', text: 'Accounting software installation, company file setup, data recovery, and multi-user configuration.' },
      { name: 'Email & Productivity', text: 'Outlook, Gmail, and productivity app configuration, syncing, and troubleshooting across devices.' },
      { name: 'Cloud & Backup', text: 'OneDrive, Google Drive, and Dropbox setup with automated backup and data recovery solutions.' },
      { name: 'Drivers & Updates', text: 'System driver updates, firmware patches, and software compatibility management.' },
      { name: 'Remote Software Setup', text: 'Secure remote installation and configuration of business-critical applications.' },
    ],
  },
  antivirus: {
    label: 'Antivirus Support',
    icon: 'ShieldCheck',
    items: [
      { name: 'Norton', text: 'Norton 360 installation, activation, and full system malware scans with real-time protection setup.' },
      { name: 'McAfee', text: 'McAfee Total Protection setup, subscription management, and threat removal for home and business.' },
      { name: 'Bitdefender', text: 'Advanced Bitdefender configuration, ransomware protection, and firewall optimization.' },
      { name: 'Kaspersky', text: 'Kaspersky installation, secure browsing setup, and complete virus and spyware removal.' },
      { name: 'Webroot', text: 'Lightweight cloud-based Webroot deployment with identity protection and web filtering.' },
      { name: 'Windows Defender', text: 'Built-in Windows security hardening, policy configuration, and threat monitoring.' },
      { name: 'Malware Removal', text: 'Deep-scan malware, spyware, and ransomware removal with system restoration.' },
      { name: 'Network Security', text: 'Firewall configuration, VPN setup, and network intrusion protection for businesses.' },
    ],
  },
};

export const pricingPlans = [
  {
    name: '1 Year Support',
    price: '$299.99',
    period: '/ 1 Year',
    popular: false,
    features: [
      'Unlimited remote support',
      'Software installation & updates',
      'Virus & malware removal',
      'Performance optimization',
      '24/7 phone support',
      'Email support',
      'Priority response time',
    ],
  },
  {
    name: '2 Year Support',
    price: '$499.99',
    period: '/ 2 Years',
    popular: true,
    features: [
      'Everything in 1 Year plan',
      'Hardware diagnostics',
      'Data backup assistance',
      'Network troubleshooting',
      'Free software license consultation',
      '2 free onsite visits per year',
      'Extended warranty options',
    ],
  },
  {
    name: 'Lifetime Support',
    price: '$999.99',
    period: '/ Lifetime',
    popular: false,
    features: [
      'Everything in 2 Year plan',
      'Unlimited onsite visits',
      'Free hardware upgrades consultation',
      'Dedicated support specialist',
      'Annual system health checkup',
      'Free minor repairs',
      'Business hours: same-day response',
      'Free system migration assistance',
    ],
  },
];

export const testimonials = [
  {
    quote: 'Xpert Consultant saved our business! Our entire network went down, and they had us back up in under 2 hours. Their lifetime support plan is worth every penny.',
    name: 'Sarah Johnson',
    company: 'Johnson & Associates LLC',
  },
  {
    quote: 'The best IT support we have ever had. They handled our Microsoft Office migration seamlessly and trained our staff. Highly recommend!',
    name: 'Michael Chen',
    company: 'TechStart Inc.',
  },
  {
    quote: 'Our Adobe Creative Cloud setup was a nightmare until Xpert Consultant stepped in. They optimized our workstations and now everything runs smoothly.',
    name: 'Emily Rodriguez',
    company: 'Creative Studios',
  },
];

export const heroImage = 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920';
